import classNames from 'classnames';
import Link, { LinkProps } from 'next/link';
import { FunctionComponent, PropsWithChildren } from 'react';
import ButtonLink from '../ButtonLink';
import { useAddReviewLink } from '../../hooks/useAddReviewLink';

export type AddCourseReviewLinkProps = PropsWithChildren<
    Omit<LinkProps, 'href' | 'as'> & {
        className?: string;
        educatorSlug: string;
        courseSlug: string;
        button?: boolean;
    }
>;

const AddCourseReviewLink: FunctionComponent<AddCourseReviewLinkProps> = ({
    educatorSlug,
    courseSlug,
    button,
    className,
    ...props
}) => {
    const url = useAddReviewLink({ educatorSlug, courseSlug });

    if (button) {
        return (
            <ButtonLink className={classNames(className)} {...url} {...props}>
                {props.children}
            </ButtonLink>
        );
    }

    return (
        <Link className={classNames(className)} {...url} {...props}>
            {props.children}
        </Link>
    );
};

export default AddCourseReviewLink;
